import axios from 'axios'
import { API_BASE, apiErrorHandler } from '../api'
import Auth from '../auth'
import { objectToSnakeCase } from '../utils'
import { default as options } from './options'
import UserEvent from './models'

const USER_EVENT_URL = `${API_BASE}user-events/`

export default class UserEventAPI {
  constructor(cls) {
    this.cls = cls
  }

  static create(cls) {
    return new UserEventAPI(cls)
  }

  /* Create a new user event. */
  create(userEvent) {
    const data = objectToSnakeCase(userEvent)
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios
      .post(USER_EVENT_URL, data, options)
      .then((res) => this.cls.fromAPI(res.data))
      .catch(apiErrorHandler({ apiName: 'Create User Event API error' }))
  }

  /* Retrieve a user event. */
  async retrieve(userEventId) {
    const url = `${USER_EVENT_URL}${userEventId}/`
    const options = {
      headers: await Auth.getHeaders(),
    }
    return axios
      .get(url, options)
      .then((response) => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Retrieve User Event API error' }))
  }

  /* Update a user event. */
  async update(userEvent, fields = [], excludeFields = []) {
    const url = `${USER_EVENT_URL}${userEvent.id}/`
    let data = this.cls.toAPI(userEvent, fields, excludeFields)
    const options = {
      headers: await Auth.getHeaders(),
    }
    return axios
      .patch(url, data, options)
      .then((response) => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Update User Event API error', rethrowErrors: true }))
  }

  employeeCodeVerificationAttempts() {
    const url = `${USER_EVENT_URL}verification-attempts/`
    const data = {}
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios.post(url, data, options).then((res) => this.cls.fromAPI(res.data))
  }

  requestStartBlocked() {
    const url = `${USER_EVENT_URL}request-start-blocked/`
    const data = {}
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios.post(url, data, options).then((res) => this.cls.fromAPI(res.data))
  }

  async requestUpdateCompletionStatus(request, currentStep) {
    let request_status = await this.requestCompletionStatus(request)

    // The event doesn't exist yet, so create it
    if (!request_status) {
      const requestStatusEvent = UserEvent.create({
        eventType: options.REQUEST_COMPLETION_STATUS,
        request: request,
        verificationAttempts: null,
        currentStep: currentStep,
      })
      return this.create(requestStatusEvent)
    }

    // Check if we need to update the current step, if we're at the request summary don't update
    if (
      request_status.currentStep !== currentStep &&
      request_status !== options.REQUEST_STEP_SUMMARY
    ) {
      request_status.currentStep = currentStep
      return UserEvent.fromAPI(await this.update(request_status, ['currentStep']))
    }

    return request_status
  }

  requestCompletionStatus(request) {
    const url = `${USER_EVENT_URL}request-completion-status/`
    const data = { request: request }
    const options = {
      headers: {
        'Content-Type': 'application/json',
        ...Auth.getHeaders(),
      },
    }
    return axios.post(url, data, options).then((res) => {
      if (res.data === '') return null
      return this.cls.fromAPI(res.data)
    })
  }
}
